import { FC  } from 'react'
import { Link } from 'react-router-dom'

import './style.scss'
import CONFIG from '../../../config'
import { AuthRoles } from '../../models'
import { Title, Text, Icon } from '../../components/UI'
import logoExperts from '../../assets/img/logo-experts.svg'
import { useAuth } from '../../hooks'


type FooterProps = {
  type?: 'public' | '',
  role?: AuthRoles
}


const Footer:FC<FooterProps> = ({ type = '', role = '' })  => {

  const userCurrent = useAuth()
  const isLoggedIn = userCurrent.isLoggedIn(role)

  const getRedirect = () => {
    console.log("Logged:");
    console.log(isLoggedIn);
  }


  return (
    <footer className={`footer ${role === CONFIG.AUTH.ROLES.ADMIN || role === CONFIG.AUTH.ROLES.STANDART ? 'footer--style2' : ''}`}>
      <div className="footer_top px-5 lg:px-0" onLoad={getRedirect}>
        {(role !== CONFIG.AUTH.ROLES.ADMIN && role !== CONFIG.AUTH.ROLES.STANDART) &&
          <div className="container">
            <div className="row">
              <div className="col-3 footer_top_mw-1 mt-30">
                <Title component="h4" weight="semibold" color="primary">REDES SOCIALES</Title>

                <ul className="footer_socialmedia mt-30">
                  <li>
                    <a href="https://www.facebook.com/clinicaindisa" title="Facebook" target="_blank" rel="noreferrer" className="footer_socialmedia_icon">
                      <Icon name="facebook" />
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/ClinicaIndisa" title="Twitter" target="_blank" rel="noreferrer" className="footer_socialmedia_icon">
                      <Icon name="twitter" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/user/IndisaCL" title="Youtube" target="_blank" rel="noreferrer" className="footer_socialmedia_icon">
                      <Icon name="youtube" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/clinicaindisacl/" title="Instagram" target="_blank" rel="noreferrer" className="footer_socialmedia_icon">
                      <Icon name="instagram" />
                    </a>
                  </li>
                </ul>
              </div>

              <div className="col footer_top_mw-2 mt-40 lg:mt-30">
                <Title component="h4" weight="semibold" color="primary">CONTACTOS</Title>

                <div className="row mt-25">
                  <div className="col-12 lg:col-6">
                    <div className="d-flex">
                      <Icon name="phone" className="mt-5" />
                      <div className="ml-15">
                        <Text component="label" color="primary" size="16">MESA CENTRAL</Text>
                        <a href="tel:223625400" className="d-block">
                          <Text component="span" size="16">2 2362 5400</Text>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 lg:col-6 mt-25 lg:mt-0">
                    <div className="d-flex">
                      <Icon name="phone" className="mt-5" />
                      <div className="ml-15">
                        <Text component="label" color="primary" size="16" className="text-nowrap">RESERVA DE HORAS</Text>
                        <a href="tel:223625400" className="d-block">
                          <Text component="span" size="16">2 2362 5400</Text>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 lg:col-6 mt-25 lg:mt-25">
                    <div className="d-flex">
                      <Icon name="email" className=""/>
                      {isLoggedIn ? (
                        <div className="ml-15 mt-5">
                          <Text component="label" color="primary" size="16" className="text-nowrap">  
                              <Link to={CONFIG.ROUTES.DASHBOARD.CONTACT} className="option_link_main mt-5">FORMULARIO DE CONTACTO</Link>
                          </Text>
                        </div>
                      ) : (
                        <div className="ml-15">
                          <Text component="label" color="primary" size="16" className="text-nowrap">  
                            <a target="_blank" rel="_noreferrer" href="https://www.indisa.cl/formulario-de-contacto/?reason=mi-portal-indisa" className="d-block mt-10">FORMULARIO DE CONTACTO</a>
                          </Text>
                        </div>
                      )}
                    </div>
                  </div>

                </div>
              </div>

              <div className="col footer_top_mw-3 d-none lg:d-block text-right">
                <img src={logoExperts} alt="" width="157" height="157" />
              </div>
            </div>
          </div>
        }
      </div>

      <div className="footer_bottom">
        <div className={`${role === CONFIG.AUTH.ROLES.ADMIN || role === CONFIG.AUTH.ROLES.STANDART ? '' : 'mt-auto pl-20 pb-20 lg:p-0 lg:mt-0'}`}>
          <p className="footer_copyright">© 2025 Clínica INDISA</p>
          <a href={`${type === '' ? 'https://www.indisa.cl/files/2021/08/PORTAL_Terminos-y-condiciones.pdf' : 'https://www.indisa.cl/files/2021/07/terminos-condiciones-web-indisa.pdf'}`} target="_blank" rel="noreferrer"className="footer_text">Términos y condiciones web</a>
        </div>

        {(role !== CONFIG.AUTH.ROLES.ADMIN && role !== CONFIG.AUTH.ROLES.STANDART) &&
          <div className="lg:d-none fz-0 ml-auto">
            <img src={logoExperts} alt="" width="128" height="128" />
          </div>
        }
      </div>
    </footer>
  )
}

export { Footer }